var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag,n){return _c('a',{key:n,staticClass:"tag size-large",attrs:{"target":"_blank","href":("https://www.instagram.com/explore/tags/" + tag + "/")}},[_vm._v("\n      #"+_vm._s(tag)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fffc31c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/route-tags.vue
// module id = 184
// module chunks = 1